module.exports = __webpack_public_path__ + "static/img/p-s4-8.03792b9d.png";